var CoordinateShape = require('../coordinate'),
    ZoneReasonCodeCollection = require('../../../../FV/reasonCodes/shapeReasonCodes'),
    AvailableZoneReasonCodes = require('../../../../FV/reasonCodes/shapeAvailableReasonCodes'),
    fvChannel = require('glRadio').channel('FV'),
    _ = require('underscore');



module.exports = CoordinateShape.extend({

    APPLY_LAST_REASON_CODES_FROM_LOCAL_STORAGE: 1,
    APPLY_LAST_FILL_FROM_LOCAL_STORAGE: 1,

    STORE_SELECTED_FILL_TO_LOCAL_STORAGE: 1,
    STORE_LAST_REASON_CODES_TO_LOCAL_STORAGE: 1,

    hasCustomizableProperties: 1,

    constructor: function(attrs, options) {

        CoordinateShape.prototype.constructor.apply( this, arguments );

        // A collection of redaction code models that are later converted back to array format for persistence
        // Should rename
        this.colRedactionCodes = this.generateReasonCodeCollectionOnParse(attrs);

        // Necessary to set flag on the shape level to indicate if it's being converted (can't just use the higher level note model )
        this.isConvertingToFloatingCodes = options.isConvertingToFloatingCodes;

        // Really a UI model attribute: utilized to centralize logic from multiple dialog views
        // to see if codes changed/where added in the views by the user
        // Not always set on close on a dialog -- eg for find and redact, needed when hit search
        this.selectedCodesOnDialogOpen = null;
        this.selectedFillOnDialogOpen = null;


    },
    defaults: function() {

        var lastRedactionFill = fvChannel.request('localStorage').getLastRedactionFill();

        return _.extend( {}, CoordinateShape.prototype.defaults.apply( this, arguments ), {

            fill: lastRedactionFill
                ? lastRedactionFill
                : 'WHITE_BLACK_BORDER',
            comments: null, // * besides fill, those sent to server -- remove fill default? */
            reasonCodes: null // obj: {code ,description, active, .. everything from the reasonCode model; corresponds to this.colRedactionCodes }
        });

    },

    /**
     * Logic to apply codes from local storage (old notes when this was on view):
     * 1) New Notes: new shape created -- apply last codes if they exist (won't be called for others when toggle on/off)
     * 2) Not New Note
     *      a) After save or render from the model: don't apply the last codes
     *      b) Modify existing and a newly created shape, not rendered from the model: apply the codes
     * Sum: if not rendered from the model (isNewlyDrawn), apply the code from local storage, otherwise do not
     * Note: not called again after initial render of note and select/deselect different shapes
     * applyFromLastUsedReasonCodes:
     * - Perhaps this is a function ... but cleaner way than this flag ... maybe the flag is on the uiModel
     * - currently need to check parentNote to see if flag set ( shapeModel is not subclassed ) ... should refactor ....
     */
    generateReasonCodeCollectionOnParse: function( attrs ) {

        var sm = this,
            applyFromLastUsedReasonCodes =
                ( this.parentNote.isFindAndRedactNote && !this.parentNote.isFromAPI )||   // latter: is for notes passed through the API by user
                ( sm.APPLY_LAST_REASON_CODES_FROM_LOCAL_STORAGE && this.uiModel.get('isNewlyDrawn') ),
            shapeReasonCodeAttributes = [];

        // Populate from the last used codes from local storage, if those from local storage exist in the system.
        // Get the description and other attributes from the locally stored codes from the system codes collection ( we only store the code )
        if ( applyFromLastUsedReasonCodes ) {

            var lastRedactionCodes = fvChannel.request('localStorage').getLastReasonCodes(),
                systemReasonCodeModels = fvChannel.request('reasonCodes'), // ( empty array if none exist )
                systemReasonCodeModelCodes = systemReasonCodeModels.pluck('code');

            var lastUsedCodesThatExistInSystemCodes = _.filter( lastRedactionCodes, function( c ) {
                return _.contains( systemReasonCodeModelCodes, c );
            });
            
            shapeReasonCodeAttributes = _.map( lastUsedCodesThatExistInSystemCodes, function(code) {

                return systemReasonCodeModels.findWhere({code: code}).toJSON();
            });

            // Filter out any that aren't active on way in ( still storing last used ones on way out )
            // ( Alternative is whenever we write them out, don't write them ... either works, though this logic is more consistent )
            shapeReasonCodeAttributes = _.filter( shapeReasonCodeAttributes, function(codeAttrs) {
               return codeAttrs.active;
            });

        } else {

            shapeReasonCodeAttributes = attrs.reasonCodes;

        }

        return new ZoneReasonCodeCollection( shapeReasonCodeAttributes );

    },

    getReasonCodeCollection: function() {
        return this.colRedactionCodes;
    },

    setReasonCodeCollection: function( reasonCodes ) {
        this.colRedactionCodes = reasonCodes;
    },

    /*
    * ( I don't think this would ever get called if 'active', though could be that in here explicitly )
    * */
    getNonPathInactiveSVGAttrs: function() {

        if ( this.uiModel.get('isExpanded') || !fvChannel.request('localStorage').getPgModeApplyAllRedactions() )
            return CoordinateShape.prototype.getNonPathInactiveSVGAttrs.apply( this, arguments );

        var BLACK = '#000000',
            WHITE = '#ffffff',
            shapeFill = this.get('fill');

        return {
            stroke: shapeFill === 'WHITE' ? WHITE : BLACK,
            fill: shapeFill === 'BLACK' ? BLACK : WHITE,
            'stroke-width': shapeFill === 'WHITE_BLACK_BORDER' ? 2 : 0,
            'fill-opacity': 1
        };

    },

    /**
     * (This would only be for non-floating codes ).
     * When not in redaction preview mode, the see through color is no longer hard-coded --
     * it's the same as the shape ( DVBC-1812).  After some experiment, this seems the best
     * option.  There is always a black fill so you can see the letters, even for light colors.
     * Also, there's no need to determine white/black text depending on the background, since the
     * zones have opacity.
     */
    getReasonCodeSvgAttrs: function( derivedSeeThroughColor ) {

        if ( this.uiModel.get('isActive') || this.uiModel.get('isExpanded') || !fvChannel.request('localStorage').getPgModeApplyAllRedactions() ) {

            return {
                fill: derivedSeeThroughColor,
                stroke: '#000000',
                'stroke-width': 1,
                'font-family': 'Courier New' // Match the CRE's font
            };

        } else {

            // apply all redaction attributes
            return {
                fill: this.get('fill') === 'BLACK' ? '#ffffff' : '#000000',
                'font-family': 'Courier New', // Match the CRE's font
                stroke: 'none', // need for toggling between the 2
                'stroke-width': 0 // probably unnecessary
            };

        }

    },

    getAvailableCodesToSelectInZoneDialog: function() {

        // Always add the active reason code models to choose from
        var rcModels =
            fvChannel.request('reasonCodes').getActiveReasonCodes().models;

        /**
         *  Now add inactive code models already on the zone.
         *  ( only applicable to existing notes ---  inactive codes from local storage are not read in ).
         *  Here we add all of the codes, inactive/not: this is to avoid logic in the node server
         *  to sync the active status of codes from the system and shape.
         *  Backbone's collection will not add duplicate models, and since those from the system are added first,
         *  they will take precedence.
         *  You'd want to do this anyway, but the point is moot because user's cannot delete codes applied to
         *  documents -- before this -- they would have been 'reassigned' but that feature has been taken away.
         *  Bottom line is all codes on the prod server will be the same whether from fdd.reason_codes or the stored on note zones.
         *  This now also handles the Non-Responsive reason code being added to full page redactions if for some reason
         *  it no longer exists in the system.
         */

        var zoneCodes = this.getReasonCodeCollection();
        if ( zoneCodes && zoneCodes.length > 0 ) {
            rcModels = rcModels.concat( zoneCodes.models ); // ( .getInactiveCodes() )
        }

        return new AvailableZoneReasonCodes( rcModels );

    },

    getAttrsToPersist: function(scale) {

        var baseAttrs = CoordinateShape.prototype.getAttrsToPersist.apply(this, arguments);

        var attrs = _.extend( {}, baseAttrs, {
            fill: this.get('fill'),
            reasonCodes: this.getReasonCodeCollection().toJSON()
        });

        if ( this.get('comments') && this.get('comments').length > 0 )
            attrs['comments'] = this.get('comments');

        return attrs;
    },

    /**
     * TODO:
     * - make an object?
     */
    setSelectedCodeAndFillOnDialogOpen: function( codeCollection, fill ) {

        /* Clone so it's not the same reference for later comparison to the original */
        this.selectedCodesOnDialogOpen = codeCollection || this.getReasonCodeCollection().clone();
        this.selectedFillOnDialogOpen = fill || this.get('fill');

    },

    getSelectedFillOnDialogOpen: function() {
        return this.selectedFillOnDialogOpen;
    },

    getSelectedCodesOnDialogOpen: function() {
        return this.selectedCodesOnDialogOpen;
    },

    /* Return selected codes that weren't added since open, or null if there were none */
    selectedCodesAddedSinceDialogOpen: function( selectedCodes ) {

        selectedCodes = selectedCodes || this.getReasonCodeCollection();

        var originalCodes = this.selectedCodesOnDialogOpen.pluck('code'),
            currentCodes = selectedCodes.pluck('code'),
            codesAdded = _.difference( currentCodes, originalCodes );

        return codesAdded.length > 0
            ? codesAdded
            : null;

    },


    // Return true if the selectedCodes changed between opening and closing the dialog
    // Put on here for consistency with other consolidating code ( from original redaction prop dialog ).
    selectedCodesChangedSinceDialogOpen: function( selectedCodes ) {

        selectedCodes = selectedCodes || this.getReasonCodeCollection();

        var selectedCodesOnDialogOpen = this.getSelectedCodesOnDialogOpen();

        if ( selectedCodesOnDialogOpen.length !== selectedCodes.length )
            return true;

        var originalCodes = selectedCodesOnDialogOpen.pluck('code'),
            currentCodes = selectedCodes.pluck('code');

        return  _.difference( currentCodes, originalCodes ).length > 0 ||
            _.difference( originalCodes, currentCodes ).length > 0;

    },

    /**
     * Centralized local here for several UI's.
     * Not necessarily from a dialog close -- eg a find and redact search.
     * Find and redact search: we don't need to check the 'original' values changed:
     * - these are always new and created from local storage
     * - except for getting which ones were added
     * resetWithCurrentValuesAfterUpdate: update the properties at end of routine ( maybe just always do this ).
     */
    updateLocalStoragePostDialogClose: function( resetWithCurrentValuesAfterUpdate ) {

        var localStorage = fvChannel.request('localStorage');

        if ( this.STORE_SELECTED_FILL_TO_LOCAL_STORAGE && this.get('fill') !== this.getSelectedFillOnDialogOpen() ) {
            localStorage.setLastRedactionFill( this.get('fill') );
        }

        // Even for F&R search do it ( doesn't hurt) AND for F&R dialog only on change
        // ( if open dialog that is difference, don't set value to it )
        if ( this.STORE_LAST_REASON_CODES_TO_LOCAL_STORAGE && this.selectedCodesChangedSinceDialogOpen() ) {
            localStorage.setLastReasonCodes( this.getReasonCodeCollection().pluck('code') );
        }

        // Only add codes selected since dialog open to the most used
        // New zones automatically populate those from the last
        var codesAddedSinceOpen = this.selectedCodesAddedSinceDialogOpen();
        if ( codesAddedSinceOpen ) {
            localStorage.setAppliedReasonCodeCounts( codesAddedSinceOpen );
        }

        if ( resetWithCurrentValuesAfterUpdate ) {
            this.setSelectedCodeAndFillOnDialogOpen();
        }

    }

});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/coordinate/redaction/redaction.js
 ** module id = 252
 ** module chunks = 0
 **/